module.exports = __webpack_public_path__ + "static/media/i.0b78009b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/starPilots/i.png
// module id = 2089
// module chunks = 0